export const TaskTypesRoutes = {
  ADDON: "addon",
  PRODUCT_ISSUE: "product",
  PRODUCT_QUALITY: "product_quality",
  CUSTOM: "custom",
  NO_TASK_TYPE: "",
};
